import React from 'react';

import styles from './KpiAiAnalytics.module.scss';

const AI_PAGE_URL = 'https://telecom-ai.stage.ws.awtg.co.uk';

const KpiAiAnalytics = () => {
	return (
		<div className={styles.aiAnalyticsPageContainer}>
			<iframe
				className={styles.aiPage}
				src={AI_PAGE_URL}
				title='SCAP AI'
			/>
		</div>
	);
};

export default KpiAiAnalytics;
